

export const soraSteps = {
    title: 'How to Generate Videos with Sora 2 – Simple 3-Step Process',
    sub: 'Create professional AI-generated videos with Sora 2 in minutes. Our intuitive interface makes video generation accessible to everyone.',
    items: [
      { num: '1', title: 'Step 1: Choose Your Input Method', text: 'Select text-to-video mode with detailed prompts, or choose image-to-video to upload a reference image. Describe camera movements, actions, and styles.' },
      { num: '2', title: 'Step 2: Configure Video Settings', text: 'Choose aspect ratio for social media or cinematic content, and video duration up to 15 seconds. Balance speed with quality using rendering options.' },
      { num: '3', title: 'Step 3: Generate and Download Your Video', text: 'Click generate and preview the result. Download high-quality videos ready for social media, creative projects, or commercial use.' }
    ],
  };
